import { render, staticRenderFns } from "./recipients.vue?vue&type=template&id=d61eb4d6&scoped=true&"
import script from "./recipients.vue?vue&type=script&lang=js&"
export * from "./recipients.vue?vue&type=script&lang=js&"
import style0 from "./recipients.vue?vue&type=style&index=0&id=d61eb4d6&scoped=true&lang=css&"
import style1 from "./recipients.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d61eb4d6",
  null
  
)

export default component.exports